import { inject, Injectable }     from '@angular/core';
import { Observable }             from 'rxjs';
import { catchError, map }        from 'rxjs/operators';
import { environment }            from '../../../environments/environment';
import { SsoLogoutConfiguration } from './sso-logout-configuration';
import { UserService }            from '../../api/user/user.service';
import { RestService }            from '../rest.service';
import { LoginResult }            from './data/login-result';
import { SessionChangedData }     from './data/session-changed-data';
import { IframeService }          from '../iframe.service';

export enum GrantType {
  CODE = 'CODE',
  REFRESH = 'REFRESH'
}

@Injectable({
  providedIn: 'root'
})
export class SsoService {
  private userService = inject(UserService);
  private restService = inject(RestService);

  ssoLogin(code: string, pingAppName: string, type: string): Observable<LoginResult> {
    return this.userService.loginSsoUser(code, pingAppName, type)
      .pipe(catchError(() => {
        throw new Error('Login failed!');
      }));
  }

  getSsoLogoutUrl(): Observable<string> {
    return this.restService.get<SsoLogoutConfiguration>(environment.api.endpoints.ssoLogout)
      .pipe(
        map(ssoLogoutConfig => {
          const logoutUri = `${window.location.origin}/logout`;
          const queryParams = `client_id=${ssoLogoutConfig.clientId}&${ssoLogoutConfig.postLogoutRedirectUri}=${logoutUri}`;
          return `${ssoLogoutConfig.baseLogoutUrl}?${queryParams}`;
        }));
  }

  refreshSession(): Observable<SessionChangedData> {
    const runsInIframe = {runsInIframe: IframeService.runsInIframe()};
    return this.restService.post(environment.api.endpoints.ssoTokenRefresh, {}, {params: runsInIframe});
  }
}